"use client"

import React, { useState, useCallback } from "react";

import {
  DescriptionTab,
  ReviewsTab,
  AdditionalInfoTab,
  TabNavigation,
  type TabId,
} from "./Tabs";

import { ProductCustomFields, Review } from "@nusrif/types";

interface ProductTabsProps {
  description: string;
  details: ProductCustomFields;
  reviews: Review[];
}

export const ProductTabs = React.memo(
  ({ description, details, reviews }: ProductTabsProps) => {
    const [activeTab, setActiveTab] = useState<TabId>("description");
    const handleTabChange = useCallback((tab: TabId) => {
      setActiveTab(tab);
    }, []);

    return (
      <div className="space-y-4">
        {/* Tab Navigation */}
        <TabNavigation activeTab={activeTab} onTabChange={handleTabChange} />
        {/* Tab Content */}
        <div className="py-4">
          {activeTab === "description" && (
            <DescriptionTab description={description} />
          )}
          {activeTab === "additional" && (
            <AdditionalInfoTab details={details} />
          )}
          {activeTab === "reviews" && <ReviewsTab reviews={reviews} />}
        </div>
      </div>
    );
  }
);
ProductTabs.displayName = "ProductTabs";
